import React from "react";
import LegalShell from "@/components/LegalShell";

export default function Cookies() {
  return (
    <LegalShell title="Politique cookies" lastUpdated="6 février 2026" testId="page-cookies">
      <p>Cette page détaille les cookies et technologies similaires utilisés par Student Hub, conformément aux recommandations de la CNIL et au RGPD.</p>

      <h2>Cookies strictement nécessaires (sans consentement)</h2>
      <ul>
        <li><strong>access_token</strong> — cookie d'authentification (httpOnly, SameSite=None, Secure). Durée : 24 heures.</li>
        <li><strong>refresh_token</strong> — renouvellement de session sécurisé. Durée : 7 jours.</li>
        <li>Ces cookies sont indispensables au fonctionnement de l'application (connexion, sécurité). Ils ne peuvent pas être désactivés.</li>
      </ul>

      <h2>Préférences locales (localStorage, pas de cookie)</h2>
      <ul>
        <li><strong>cookie_consent_v1</strong> — mémorise ton choix sur la bannière cookies (durée illimitée jusqu'à effacement manuel).</li>
        <li><strong>trial_banner_dismissed_at</strong> — masque le bandeau du compte à rebours pendant 12 heures.</li>
      </ul>

      <h2>Aucun cookie tiers, aucun tracker</h2>
      <p>Student Hub n'utilise <strong>aucun</strong> outil de mesure d'audience tiers (Google Analytics, Meta Pixel, etc.), aucun cookie publicitaire, aucun tracker comportemental. Les images et logos affichés depuis Clearbit ou Unsplash ne déposent pas de cookie persistant.</p>

      <h2>Outils tiers déclarés</h2>
      <ul>
        <li><strong>Stripe / PayPal</strong> : leurs propres cookies sont posés uniquement lorsque tu cliques pour payer (sur leurs domaines, pas le nôtre).</li>
        <li><strong>Resend</strong> : envoi d'emails ; aucun cookie posé sur le navigateur.</li>
      </ul>

      <h2>Gérer tes préférences</h2>
      <p>Tu peux à tout moment :</p>
      <ul>
        <li>Supprimer ton choix de bannière en effaçant les données locales du site (Paramètres navigateur → Cookies & données → Supprimer pour studenthubfrance.fr).</li>
        <li>Activer le mode « Ne pas suivre » de ton navigateur (DNT).</li>
        <li>Refuser les cookies non essentiels via la bannière (clic sur « Essentiels uniquement »).</li>
      </ul>

      <h2>Contact</h2>
      <p>Pour toute question relative aux cookies : <strong>contact.servicedecomdu64@gmail.com</strong>.</p>
    </LegalShell>
  );
}
